import React, { HTMLAttributes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import { TextInput } from 'sos-common/js/components/FormControls/TextInput';
import { Tooltip } from 'sos-common/js/components/Tooltip/Tooltip';
import { RadioButtonGroup } from 'sos-common/js/components/FormControls/RadioButtonGroup';
import { RadioButton } from 'sos-common/js/components/FormControls/RadioButton';
import { GroupedComponentsValidator } from 'sos-common/js/components/FormControls/GroupedComponentsValidator';
import { StepChildProps } from 'sos-common/js/components/WizardStepper/WizardStepper.types';
import { makeTranslator, translateFunc } from '../../../utilities/translations';
import {
  FieldStates,
} from 'sos-common/js/commonTypes/formField.types';
import { ValidationResult, StepValidationMap } from 'sos-common/js/commonTypes/validation.types';
import { QualityRegisterOrderModel, QualityRegisterOrderStore, QualityRegisterOrderRegisters } from '../../../models';
import {
  setFormValue,
  addFileActionFunc,
  removeFileActionFunc
} from 'sos-eservice-common/js/Redux/Actions';
import { getErrorMessageByFieldName, getErrorMessageByFieldNameAfterHitSummary } from '../../../utilities/helpers';
import { setQualityRegistersValue } from '../actions/quality.registers.actions';
export interface Step1Props extends StepChildProps {
  Translate?: translateFunc;
  registers?: QualityRegisterOrderRegisters;
  setFormValue?: typeof setFormValue;
  setQualityRegistersValue?: typeof setQualityRegistersValue;
  formModel: QualityRegisterOrderModel;
  hasHitSummary: boolean;
  deleteFile: removeFileActionFunc;
  postFile: addFileActionFunc;
  orderId: string;
  validationResults: ValidationResult[];
  stepValidationMap: StepValidationMap;
}
export interface Step1State {
  isValid: boolean;
  stepId: number;
  shouldShowOtherInit: boolean;
  otherIsTouched: boolean;
}

const OTHER_REG_VALUE = Number.MIN_SAFE_INTEGER;
class Step1 extends React.Component<Step1Props, Step1State> {
  private _shouldShowOtherInit: boolean;
  constructor(props: any) {
    super(props);
    const initRegVal = this.getRegisterInitValue();
    let shouldShowOtherInit = false;
    if (initRegVal === OTHER_REG_VALUE) shouldShowOtherInit = true;

    this.state = {
      isValid: this.props.stepState.isDone,
      stepId: this.props.stepState.stepId,
      shouldShowOtherInit,
      otherIsTouched: false
    };
  }
  getTitle = () => 'Kvalitetsregister';

  onChangeField = (field: FieldStates) => {
    if (field.fieldName === 'QualityRegister' && field.value !== OTHER_REG_VALUE) {
      this._shouldShowOtherInit = false;
      this.setState({
        shouldShowOtherInit: false
      });
      // this.props.setFormValue({
      //   fieldName: 'OtherQualityRegister',
      //   value: ''
      // });
    } else if (field.fieldName === 'QualityRegister' && field.value === OTHER_REG_VALUE) {
      this.setState({
        shouldShowOtherInit: true
      });
    }

    if (field.fieldName === 'OtherQualityRegister' && !this.state.otherIsTouched) {
      this.setState({
        otherIsTouched: true
      });
    }

    this.props.setQualityRegistersValue(field);
  };

  getRegisterInitValue = () => {
    const { formModel } = this.props;
    const qr = _.get(formModel, 'QualityRegister');
    const oqr = _.get(formModel, 'OtherQualityRegister');
    if (qr) return qr;
    if (oqr) return OTHER_REG_VALUE;
    return 0;
  };

  getRegisterErrorMessage = () => {
    const { validationResults, hasHitSummary, formModel } = this.props;
    const { otherIsTouched } = this.state;
    if (hasHitSummary && !_.get(formModel, 'QualityRegister') && !_.get(formModel, 'QualityRegister')) {
      return 'Välj ett kvalitetsregister';
    }
    if (otherIsTouched || hasHitSummary) return getErrorMessageByFieldName(validationResults, 'QualityRegister');
    return '';
  };

  componentDidMount() {
    this.props.reportToWizard({
      stepLabel: this.getTitle()
    });
  }

  private getGroupedErrorMessageObject = (fieldName: string, afterHitSummary: boolean) => {
    const { validationResults, hasHitSummary } = this.props;
    let errorMessage = '';
    if (afterHitSummary) {
      errorMessage = getErrorMessageByFieldNameAfterHitSummary(validationResults, fieldName, hasHitSummary);
    } else {
      errorMessage = getErrorMessageByFieldName(validationResults, fieldName);
    }

    const id = fieldName + '-errormessage';
    let ariaAttributes = {} as HTMLAttributes<any>;
    if (errorMessage) {
      ariaAttributes['aria-invalid'] = true;
      ariaAttributes['aria-describedby'] = id;
    } else {
      ariaAttributes = null;
    }
    return { errorMessage, id, ariaAttributes };
  };

  render() {
    const { Translate, registers, formModel, hasHitSummary, orderId, validationResults } = this.props;
    const { qualityRegistries } = registers;
    const noResearchOrderId = !orderId;
    const shouldShowOther = !!(_.get(formModel, 'QualityRegister') === OTHER_REG_VALUE);

    const QualityRegisterErrorMessageObject = this.getGroupedErrorMessageObject('QualityRegister', true);

    return (
      <div id="step1" tabIndex={-1}>
        <p>{Translate('/orderFormPage/starOblig')}</p>
        <div className="form-group" role="group" aria-labelledby="vilketregLabel">
          <h2 id="vilketregLabel" className="inlineblock">
            {Translate('/qualityFormPage/vilketreg')} *
          </h2>
          <div className="inlineblock">
            <Tooltip text={Translate('/infobubblorKvalitetsRegister/vilketregInfo')} />
          </div>
          <div className="form-group-small">
            <GroupedComponentsValidator
              errorId={QualityRegisterErrorMessageObject.id}
              errorMessage={this.getRegisterErrorMessage()}
            >
              <RadioButtonGroup
                value={this.getRegisterInitValue()}
                fieldName="QualityRegister"
                onChange={this.onChangeField}
                errorAriaAttributes={QualityRegisterErrorMessageObject.ariaAttributes}
                isRequired={true}
              >
                {qualityRegistries.map(reg => {
                  return <RadioButton key={reg.DhsId} value={reg.DhsId} label={reg.Name} />;
                })}
                <RadioButton key={0} value={OTHER_REG_VALUE} label={Translate('qualityFormPage/otherRegTitle')} />
              </RadioButtonGroup>
            </GroupedComponentsValidator>
            {this.state.shouldShowOtherInit && (
              <div className="indent">
                <TextInput
                  fieldName="OtherQualityRegister"
                  placeholder={Translate('qualityFormPage/otherRegPlaceholder')}
                  value={_.get(formModel, 'OtherQualityRegister')}
                  onChange={this.onChangeField}
                  maxLength={160}
                  isRequired={true}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapState2Props = (state: QualityRegisterOrderStore) => {
  return {
    Translate: makeTranslator(state.globals.translations),
    registers: state.registers,
    formModel: state.formModel,
    orderId: state.globals.orderId,
    hasHitSummary: state.globals.hasHitSummary,
    validationResults: state.validationState.validationResults,
    stepValidationMap: state.validationState.stepValidationMap
  } as Partial<Step1Props>;
};

const mapDispatch2Props = dispatch => {
  return {
    setFormValue: bindActionCreators(setFormValue, dispatch),
    setQualityRegistersValue: bindActionCreators(setQualityRegistersValue, dispatch)
  };
};

const StepOne = connect(
  mapState2Props,
  mapDispatch2Props
)(Step1);
export { StepOne };
